import styled from 'styled-components';
import palette from './Button.palette';

const presetColors = ({ color = 'primary', theme, ghost = 'false' }) => {
  const { bg, text } = palette[color];
  const { set } = palette;
  const textColor = theme[set][text.color];
  const bgColor = theme[set][bg.color];
  const ghostText = palette[color].ghostText || text;

  return ghost ? `
    background: transparent;
    color: ${bgColor[bg.normal]};
    border-color: ${bgColor[bg.normal]};

    &:hover {
      background: ${bgColor[bg.hover]};
      color: ${theme[set][ghostText.color][ghostText.hover]};
      border-color: transparent;
    }
  ` : `
    background: ${bgColor[bg.normal]};
    color: ${textColor[text.normal]};

    &:hover {
      background: ${bgColor[bg.hover]};
      color: ${textColor[text.hover]};
    }
  `
};

const disabledStyles = ({ theme }) => {
  const {
    set,
    disabled: { text, bg }
  } = palette;

  return `
    background: ${theme[set][bg.color][bg.normal]};
    color: ${theme[set][text.color][text.normal]};
    pointer-events: none;
    cursor: default;
    border-color: transparent;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.07);
  `;
};

const smallStyles = `
  font-size: 12px;
  min-height: 39px;
`;

export const defaultButtonStyles = `
  width: 251px;
  font-size: 14px;
  line-height: 20px;
  box-sizing: border-box;
  min-height: 56px;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: bold;
  text-transform: uppercase;
  background: transparent;
  color: inherit;
  cursor: pointer;
  margin: 0;
  border: 1px solid transparent;
  padding: 0 10px;
  outline: none;
  position: relative;
  user-select: none;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;
  appearance: none;
  border-radius: 3px;
  font-family: 'Brandon Text';
  display: block;
`;

export const conditionalStyles = props => {
  return [
    props.disabled && disabledStyles(props),
    props.small && smallStyles
  ].filter(Boolean).join('');
}

export const DefaultButton = styled.button<{
  small?: boolean;
  color?: string;
  ghost?: boolean;
  disabled?: boolean;
}>`
  ${defaultButtonStyles}
  ${presetColors}
  ${conditionalStyles}
`;
